var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"no-box-shadow",attrs:{"max-width":"90vw","max-height":"90vh","width":"fit-content","value":_vm.show},on:{"click:outside":_vm.onClose}},[_c('div',{on:{"click":_vm.onClose}},[_c('ImageZoom',{attrs:{"image":_vm.image,"image-thumb":_vm.imageThumb || _vm.image}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }